/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_File_Write_Not_AllowedInputs */



/**
* | output |
* | --- |
* | "File access has not been granted for this app." |
*
* @param {Canvas_File_Write_Not_AllowedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_file_write_not_allowed = /** @type {((inputs?: Canvas_File_Write_Not_AllowedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_File_Write_Not_AllowedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Für diese App wurde kein Dateizugriff erteilt.")
	return /** @type {LocalizedString} */ ("File access has not been granted for this app.")
});